import { DividerStyled } from './DividerStyled';

interface DividerProps {
  large?: boolean;
}

export const Divider = ({ large = false }: DividerProps) => (
  <DividerStyled data-testid="divider" $large={large} />
);
